module.exports = __webpack_public_path__ + "img/00014.68f0fda6.webp";